import React from "react";

const CustomIcon = ({
    fill = null,
    stroke = null,
    postText = "",
    className = "",
    width = 14,
    height = 13,
    isCore = false,
}) => {
    const filing = fill || (isCore ? "black" : "white");
    const strokeValue = stroke || (filing === "white" ? "black" : null);

    return (
        <span className={className}>
            <svg
                width={width}
                height={height}
                viewBox="0 0 14 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke={strokeValue}
                    fill={filing}
                    d="M12.1188 0.8766C10.7682 -0.28689 9.0068 0.0291752 8.814 0.0684812C8.68638 0.0605553 7.74258 0.00280949 7.00076 0.00280949C6.25894 0.00280949 5.31498 0.0605553 5.18752 0.0684812C4.99456 0.0290135 3.23335 -0.287052 1.88252 0.876438C0.88746 1.73357 0.382812 3.16816 0.382812 5.14009V5.2614H2.64944V13H11.3518V5.2614H13.6187V5.14009C13.6187 3.16816 13.1141 1.73357 12.1188 0.8766ZM7.00076 0.245439C7.62828 0.245439 8.40162 0.287172 8.69403 0.304317C8.56688 1.32433 7.22034 1.80037 7.00076 1.87106C6.78149 1.8007 5.43449 1.32563 5.30748 0.304317C5.59974 0.287172 6.37309 0.245439 7.00076 0.245439Z"
                />
            </svg>
            {postText && <span>{postText}</span>}
        </span>
    );
};

export default CustomIcon;
